// extracted by mini-css-extract-plugin
export default {"formText":"customSearch_formText__4mDPu","CustomSearchBar":"customSearch_CustomSearchBar__IXlPk","searchIcon":"customSearch_searchIcon__fdiV-"};